// @flow
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";

import { reloadModel } from "../redux/_modularui/ModularUIActions";
import { MODULARUI_STATUS } from "../constants/Constants";

import type { ModularUIModel } from "../models/types";
import type { ReduxState, ModelEntry } from "../redux";

type ReloadCallback = (model: ModularUIModel) => boolean;

type UseModels = () => {
  reload: (model: ModularUIModel, options?: any) => void,
  reloadWithFilter: (callbackFn: ReloadCallback, options?: any) => void,
};

/**
 * Hook that contains the reload property that can be used to reload a model
 */
export const useModels: UseModels = () => {
  const dispatch = useDispatch();

  const selectModularUI = (state: ReduxState) => state.modularui;
  const selector = createSelector([selectModularUI], (modularui) => {
    const models = [];
    const keys = Object.keys(modularui);
    for (const key of keys) {
      const model: ModelEntry = modularui[key];
      if (model?.status === MODULARUI_STATUS.FINISHED) {
        models.push(model.model);
      }
    }
    return models;
  });

  const modularuiModels = useSelector(selector);

  return {
    reload: (model: ModularUIModel, options?: Object) => {
      dispatch(reloadModel(model, options));
    },
    reloadWithFilter: (callbackFn: ReloadCallback, options?: Object) => {
      const modelsToReload = modularuiModels.filter(callbackFn);
      for (const modelToReload of modelsToReload) {
        dispatch(reloadModel(modelToReload, options));
      }
    },
  };
};
